export default {
  question_no: [
    { required: true, message: '請輸入題目編號', trigger: 'change' }
  ],
  lang: [
    { required: true, message: '請選擇語言', trigger: 'change' }
  ],
  title: [
    { required: true, message: '請輸入問題', trigger: 'change' }
  ],
  level: [
    { required: true, message: '請選擇难度', trigger: 'change' }
  ],
  score: [
    { required: true, message: '請輸入分數', trigger: 'change' }
  ],
  img_url: [
    { required: true, message: '請選擇問題圖片', trigger: 'change' }
  ],
}